export default __webpack_public_path__ + "static/media/new-login-containers.76fd8bda.jpg";